import React from 'react'

type ImageItem = {url: string}

type Props = {
  images: ImageItem[]
  className?: string
}

export default function GalleryMedia({images, className}: Props) {
  const [index, setIndex] = React.useState(0)
  const [shape, setShape] = React.useState<'square' | 'auto'>('square')

  React.useEffect(() => {
    setIndex(0)
    setShape('square')
  }, [images.length])

  const handleScroll = React.useCallback(
    (event: React.UIEvent<HTMLDivElement>) => {
      const target = event.currentTarget
      const width = target.clientWidth
      if (!width) return
      const nextIndex = Math.round(target.scrollLeft / width)
      if (nextIndex !== index) {
        setIndex(Math.min(images.length - 1, Math.max(0, nextIndex)))
      }
    },
    [images.length, index],
  )

  const handleImageLoad = React.useCallback(
    (event: React.SyntheticEvent<HTMLImageElement>) => {
      const target = event.currentTarget
      if (target.dataset.index !== '0') return
      const width = target.naturalWidth
      const height = target.naturalHeight
      if (!width || !height) return
      const ratio = width / height
      if (ratio < 0.9 || ratio > 1.1) {
        setShape('auto')
      } else {
        setShape('square')
      }
    },
    [],
  )

  return (
    <div
      className={['insta-media', className].filter(Boolean).join(' ')}
      data-shape={shape}>
      <div className="insta-media-track" onScroll={handleScroll}>
        {images.map((image, imgIndex) => (
          <div key={image.url ?? imgIndex} className="insta-media-item">
            <img
              src={image.url}
              alt=""
              loading="lazy"
              data-index={imgIndex}
              onLoad={imgIndex === 0 ? handleImageLoad : undefined}
            />
          </div>
        ))}
      </div>
      {images.length > 1 && (
        <div className="insta-dots" aria-hidden>
          {images.map((_, dotIndex) => (
            <span
              key={dotIndex}
              className={`insta-dot${dotIndex === index ? ' is-active' : ''}`}
            />
          ))}
        </div>
      )}
    </div>
  )
}
